import { NetworkScrollableWrapperWebComponent } from './component/NetworkScrollableWrapperWebComponent';

export { NetworkScrollableWrapperWebComponent };
